module.exports = __webpack_public_path__ + "static/content-31daf1a2849123314a9a84ad14fa9fe5.mp4";